import { Component } from '@angular/core';

interface ServiceItem {
  iconImg: string;
  titleKey: string;
  textKey: string;
}

interface ServiceStep {
  titleKey: string;
  textKey: string;
}

interface ServiceFeature {
  iconImg: string;
  titleKey: string;
  textKey: string;
}

@Component({
  selector: 'app-ourservices',
  templateUrl: './ourservices.component.html',
  styleUrl: './ourservices.component.scss'
})
export class OurservicesComponent {
  services: ServiceItem[] = [
    {
      iconImg: 'assets/as/48.webp',
      titleKey: 'atw.servicesPage.services.items.documents.title',
      textKey: 'atw.servicesPage.services.items.documents.text'
    },
    {
      iconImg: 'assets/as/13.webp',
      titleKey: 'atw.servicesPage.services.items.visa.title',
      textKey: 'atw.servicesPage.services.items.visa.text'
    },
    {
      iconImg: 'assets/as/50.webp',
      titleKey: 'atw.servicesPage.services.items.translation.title',
      textKey: 'atw.servicesPage.services.items.translation.text'
    },
    {
      iconImg: 'assets/as/27.webp',
      titleKey: 'atw.servicesPage.services.items.attestation.title',
      textKey: 'atw.servicesPage.services.items.attestation.text'
    },
    {
      iconImg: 'assets/as/33.webp',
      titleKey: 'atw.servicesPage.services.items.medical.title',
      textKey: 'atw.servicesPage.services.items.medical.text'
    },
    {
      iconImg: 'assets/as/39.webp',
      titleKey: 'atw.servicesPage.services.items.flights.title',
      textKey: 'atw.servicesPage.services.items.flights.text'
    },
    {
      iconImg: 'assets/as/26.webp',
      titleKey: 'atw.servicesPage.services.items.followup.title',
      textKey: 'atw.servicesPage.services.items.followup.text'
    }
  ];

  features: ServiceFeature[] = [
    {
      iconImg: 'assets/as/40.webp',
      titleKey: 'atw.servicesPage.features.items.trust.title',
      textKey: 'atw.servicesPage.features.items.trust.text'
    },
    {
      iconImg: 'assets/as/8.png',
      titleKey: 'atw.servicesPage.features.items.speed.title',
      textKey: 'atw.servicesPage.features.items.speed.text'
    },
    {
      iconImg: 'assets/as/17.webp',
      titleKey: 'atw.servicesPage.features.items.accuracy.title',
      textKey: 'atw.servicesPage.features.items.accuracy.text'
    }
  ];

  steps: ServiceStep[] = [
    {
      titleKey: 'atw.servicesPage.steps.items.step1.title',
      textKey: 'atw.servicesPage.steps.items.step1.text'
    },
    {
      titleKey: 'atw.servicesPage.steps.items.step2.title',
      textKey: 'atw.servicesPage.steps.items.step2.text'
    },
    {
      titleKey: 'atw.servicesPage.steps.items.step3.title',
      textKey: 'atw.servicesPage.steps.items.step3.text'
    },
    {
      titleKey: 'atw.servicesPage.steps.items.step4.title',
      textKey: 'atw.servicesPage.steps.items.step4.text'
    }
  ];

  trackByIndex(index: number): number {
    return index;
  }
}